module.exports = __webpack_public_path__ + "img/c06_unitstartechmountedarcherchampion_Normal_ua.5f6b68b5.webp";